import React, { useMemo } from 'react';
import { arrayOf, string, object, bool, shape } from 'prop-types';
import classnames from 'classnames';
import ClientList from '../ClientList';
import TopClientsTitle from '../TopClientsTitle';
import {
    getDisplayedNotableClients,
    oddsPopoverPositionLeft,
    automaticPosition
} from '../../../utils/helpers/notableClients';
import {
    reportNotableClientsHovered,
    trackUnknownInteraction,
    trackInteractionByOrigin,
    SOURCES
} from '../../../utils/reports';
import notableClientType from '../../../utils/types/notableClient';
import './style.scss';

const NotableClientsAbout = ({
    notableClients,
    seller = {},
    isSlimDesign,
    origin,
    titleProps = defaultTooltipProps,
    hideClientPopover = false,
    className = '',
    logoClassName,
    detailsPopoverProps
}) => {
    const { name: sellerName, profilePhoto } = seller;
    const displayClients = useMemo(() => getDisplayedNotableClients(notableClients), [notableClients]);
    const popoverPositionFunction = isSlimDesign ? automaticPosition : oddsPopoverPositionLeft;
    const clientListProps = {
        displayClients,
        sellerName,
        profilePhoto,
        logoClassName,
        showIndustry: true,
        hidePopover: hideClientPopover,
        popoverPositionFunction,
        detailsPopoverProps,
        clientHoverCallback: (client, position) => {
            reportNotableClientsHovered({
                client,
                position,
                origin,
                allClients: displayClients,
                component: SOURCES.BELOW_THE_FOLD
            });
            trackInteractionByOrigin({
                seller,
                client,
                origin,
                allClients: displayClients
            }, trackUnknownInteraction);
        }
    };

    const titlePropsToSupply = { ...titleProps, sellerName };

    return (
        <div className={classnames('notable-clients-about', className)}>
            <TopClientsTitle {...titlePropsToSupply}/>
            <ul className={classnames('client-list', { 'double': !isSlimDesign })}>
                <ClientList {...clientListProps}/>
            </ul>
        </div>
    );
};

const defaultTooltipProps = {
    educate: false,
    newBadge: true,
    infoIcon: true,
    classNames: {
        title: 'tbody-5'
    }
};

NotableClientsAbout.propTypes = {
    notableClients: arrayOf(notableClientType),
    seller: shape({
        name: string,
        profilePhoto: string
    }),
    isSlimDesign: bool,
    origin: string,
    hideClientPopover: bool,
    titleProps: shape({
        educate: bool,
        newBadge: bool,
        infoIcon: bool,
        classNames: object
    }),
    className: string,
    logoClassName: string,
    detailsPopoverProps: shape({
        title: string
    })
};

export default NotableClientsAbout;
